import { Component, OnInit } from '@angular/core';
import {AdoptionService} from '../../services/adoption.service';
import {Adoption} from '../../classes/adoption.interface';
import {Breed} from '../../classes/breed.interface';
import {Location} from '../../classes/location.interface';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { DoctorService } from '../../services/doctor.service';
@Component({
  selector: 'app-adoptionform',
  templateUrl: './adoptionform.component.html',
  styleUrls: ['./adoptionform.component.css']
})
export class AdoptionformComponent implements OnInit {
  user_name: any;
  doctype: any;
  documentuploadflag = 0;
  doc: any;
  usermobile: any;
  otpconfirm = 0;
  city: Location[];
  loc: any;
  filename: any;
  ssp: any;
  adoption: any;
  breed: Breed[];
  location: Location[];
  AdoptionDocument = [];
  age = ['0-1', '1-2', '2-3' , '3-4', '4-5', 'above 5'];
  color = ['Black', 'White', 'Brown', 'Gray', 'Fawn', 'Mix'];
  adopstatus= 'pending_otp';
  flag = 0;
  selected_pet_type: any;
  selected_breed: any;
  pettype = [];
  user_id: any;
  public loading = false;
  selectedcity: any;
  uploadingflag = 0;
  counter = 4;
  timer: any;
  constructor(private adoptionService: AdoptionService, private commonService: CommonService,
  private doctorservice: DoctorService) {
    window.scrollTo(0, 0);
    this.timer = setInterval(() => this.timedelay(), 1000);
  }
   ngOnInit() {
     this.loading = true;
    this.getBreeds();
    this.getAdoptionCity()
    this.getLocations();
  }
  timedelay() {
    this.counter = this.counter  - 1;
    if (this.counter === 0) {
      clearInterval(this.timer);
      const udata = this.commonService.getUserDataLocally();
      this.user_id = udata.uid;
      this.user_name = udata.uname;
     this.doctorservice.getCommentedUserDetail(this.user_id)
     .subscribe(
       (x) => {
         this.usermobile = x[0].mobile;
       if (x[0].verified === 'v') {
        this.flag = 1;
        this.adopstatus = 'waiting For Verification';
       }
      });
    }
  }
  getAdoptionLocation(lid) {
    this.loading = true;
    this.adoptionService.getLocation(lid)
    .subscribe(
      (x) => {
        this.loading = false;
        this.loc = x;
        this.createlocation();
      }
    );
  }
  createlocation() {
    for (let i = 0 ; i < this.loc.length ; i++) {
      this.location.push(this.loc[i]);
    }
  }
  getAdoptionCity() {
    this.adoptionService.getAdoptionCity()
    .subscribe(
      (x: Location[]) => {
        this.loading = false;
        this.city = x;
      }
    );
  }
  getBreeds() {
    this.adoptionService.getBreeds()
    .subscribe(
      (x: Breed[]) => {
        this.loading = false
        this.breed = x;
        for ( let i = 0 ; i < this.breed.length; i++) {
           if (this.breed[i].parent_id === 0 && (this.breed[i].name === 'dog' || this.breed[i].name === 'cat') ) {
              this.pettype.push(this.breed[i]);
           }
          }
      }
    );
  }
  getLocations() {
    this.adoptionService.getAllLocation()
    .subscribe(
      (x: Location[]) => {

        this.location = x;
      }
    );
  }

postForAdoption(form: NgForm) {
  if ( form.value.q2 === 'yes' || form.value.q3 === 'yes'){
    this.documentuploadflag = 1;
  }
  this.adoptionService.createAdoptionPost(this.user_id, form.value.petname, this.adopstatus,
    form.value.btype, form.value.gender, form.value.location, form.value.age, form.value.color,
    this.filename, this.selected_pet_type, this.selectedcity, form.value.petdesc, form.value.q1,
  form.value.q2, form.value.q3)
  .subscribe(
    (x) => {
      this.adoption = x;

      if (this.flag == 0) {
        this.otpconfirm = 1;
      }else {
        this.otpconfirm = 3;
      }
    }
  );
  }

   /*for uploading files*/
   uploadFile: any;
   hasBaseDropZoneOver: boolean = false;
   options: Object = {
     url: 'https://passport.petcart.in/images/adoption/index.php'
   };
   sizeLimit = 2000000; 

  handleUpload(data): void {
     if (data && data.response) {
       data = JSON.parse(data.response);
       this.uploadFile = data;
       this.filename = data.originalName;
     }
   }
 fileOverBase(e: any): void {
     this.hasBaseDropZoneOver = e;
   }
 beforeUpload(uploadingFile): void {
     if (uploadingFile.size > this.sizeLimit) {
       uploadingFile.setAbort();
       alert('File is too large');
     }
   }
   genOtp() {
    const otp = this.getRandomArbitrary(1000, 9000);
    this.loading = true;
    this.commonService.createOtp(this.user_id, otp)
    .subscribe(
       (x) => {
         this.loading = false;
        this.commonService.sendOtp(this.user_name, this.usermobile, otp);
        this.otpconfirm = 2
      }
    )
   }
     getRandomArbitrary(min, max) {
        const num = min + Math.random() * max;
       return Math.trunc(num);
    }
    postForOtp(form: NgForm) {
      this.loading = true;
      this.doctorservice.getCommentedUserDetail(this.user_id)
      .subscribe(
        (x) => {
          this.loading = false;
          const temp = x[0].otp;
          if (temp == form.value.otp) {
            this.verifiedUser();
          }
         });
    }
    verifiedUser() {
      this.loading = true;
      this.commonService.verifyuser(this.user_id)
      .subscribe(
        (x) => {
          this.loading = false;
          this.updateAdoptionStatus();
          this.otpconfirm = 3;
        });
    }
    addDocument() {
      this.uploadingflag = 1;
    }
    updateAdoptionStatus() {
      this.loading = true;
      this.adoptionService.updateAdoptiondata(this.adoption.id, 'waiting For Verification')
      .subscribe(
        (x) => {
          this.loading = false;
        });
    }
    CancelUpload() {
      this.uploadingflag = 0;
    }
    handleUploaddoc(data): void {
      if (data && data.response) {
        data = JSON.parse(data.response);
        this.uploadFile = data;
        this.filename = data.originalName;
      }
    }
  beforeUploaddoc(uploadingFile): void {
      if (uploadingFile.size > this.sizeLimit) {
        uploadingFile.setAbort();
        alert('File is too large');
      }
    }
    setAdoptionDocumentpath() {
      this.loading = true;
      this.adoptionService.setAdoptionDocumentPath(this.adoption.id, this.doctype, this.filename)
      .subscribe(
        (x) => {
          this.AdoptionDocument.push(x);
          this.doctype = null;
          this.filename = null;
          this.uploadFile = null;
          this.uploadingflag = 2;
          this.loading = false;
        }
      )
    }
    showFinalmessage() {
      this.otpconfirm = 4;
    }
}
